/** @module csi/widget/_svg/_SnapGridDropDownPlugin */
define([
	"dojo/_base/declare",
	"dijit/form/DropDownButton",
	"dijit/Menu",
	"dijit/CheckedMenuItem",
	"csi/_base/underscore",
	"csi/locale",
	"./_Plugin"
], function(declare,DropDownButton,Menu,CheckedMenuItem,_,locale,_Plugin) {

	return declare([DropDownButton, _Plugin], {

		/**
		 * convenience function for snap to grid drop down widgets
		 * @param  {Array[String]} options
		 */
		snapGridDropDownMenu: function (options) {
			var self = this;
			var menu = new Menu({
				"class": "svgSelect",
				style: "display: none;"
			});
			_.each(options, function (option, i) {
				var item = new CheckedMenuItem({
					label: locale.resource(option),
					iconClass: "csi-checked-menu-item-check",
					onClick: function (e) {
						self.onGridDropDownClick(e, this);
					},
					value: i,
					checked: (option === "CanvasSnapToGuides")
				});
				menu.addChild(item);
			});

			return menu;
		},

		/**
		 * Set Snap to Grid option true or false
		 * @param  {Event} e
		 * @param {Object} item
		 */
		onGridDropDownClick: function (e, item) {
			if (item.get("value")) {
				this.editor.setSnapToGuides(item.get("checked"));
			} else {
				this.editor.setSnapToGrid(item.get("checked"));
			}
		}
	});
});
